import React from "react";
import { Carousel } from "react-bootstrap";
import { BOOKINGS, SHOP } from "../data/shop";
import { Zia } from "./Zia";
import "./Splash.css";

const LOGO = "/assets/randysbarbershop.png";

const images = [
  {
    src: "/assets/splashes/ThisChristography-20200613.jpg",
    alt: "The barber chairs and stations inside Randy's Barber Shop",
  },
  {
    src: "/assets/splashes/ThisChristography-20200613-2.jpg",
    alt: "Close up of a Randy's Barber Shop cape draped over a chair",
  },
  {
    src: "/assets/splashes/ThisChristography-20200613-4.jpg",
    alt: "Caped barber chairs lined up inside Randy's Barber Shop",
  },
];

const facts = [
  `Est. ${SHOP.established}`,
  "Walk-Ins Welcome",
  "Big RJ 30 Minute Guarantee",
];

export const Splash = () => (
  <div className="splash" id="top">
    <Carousel
      controls={false}
      fade={true}
      indicators={false}
      pause={false}
      interval={6 * 1000}
    >
      {images.map((image) => (
        <Carousel.Item key={image.src}>
          <img className="d-block w-100" src={image.src} alt={image.alt} />
        </Carousel.Item>
      ))}
    </Carousel>

    <div className="splash__scrim" />

    <div className="splash__content">
      <div className="splash__logo">
        <img src={LOGO} alt="Randy's Old Fashioned Barber Shop" />
        {/* Masked to the logo art so the gleam only crosses the sign itself */}
        <span
          className="splash__logo-gleam"
          aria-hidden="true"
          style={{
            WebkitMaskImage: `url(${LOGO})`,
            maskImage: `url(${LOGO})`,
          }}
        />
      </div>

      <p className="splash__script">{SHOP.tagline}</p>

      <div className="splash__price">
        <span className="splash__price-label">Home of the</span>
        <span className="splash__price-figure gold-text">
          <sup>$</sup>30
        </span>
        <span className="splash__price-label">Old Fashioned Cut</span>
      </div>

      <div className="splash__actions">
        {BOOKINGS.map((booking, index) => (
          <a
            key={booking.url}
            className={index === 0 ? "btn-shop" : "btn-ghost"}
            href={booking.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Book with {booking.barber}
          </a>
        ))}
      </div>

      <ul className="splash__facts">
        {facts.map((fact, index) => (
          <li key={fact}>
            {index > 0 && <Zia size={13} className="splash__facts-mark" />}
            <span>{fact}</span>
          </li>
        ))}
      </ul>
    </div>

    <a className="splash__scroll" href="#about">
      <span className="splash__scroll-label">Our Story</span>
      <svg
        className="splash__scroll-arrow"
        viewBox="0 0 26 14"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M2 2l11 10L24 2"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </a>
  </div>
);
